import {CUSTOM_ERROR} from '../Config/appConfig';
import {getErrorCode} from '../ReduxRequests/Actions/errorCodeAction';

export const assertTrue = (code: number, hasResult: boolean) => {
    if (!hasResult) { throwErrorClient(code); }
    return hasResult;
};

export const assertAllTrue = (chain: Array<{ code: number, hasResult: boolean }>) => {
    chain.unshift({code: 0, hasResult: true});
    return chain.reduce((prev, curr) => {
        return assertTrue(curr.code, curr.hasResult) && prev;
    });
};

const throwError = (code: number, message: string) => {
    const event = new CustomEvent(CUSTOM_ERROR.ERROR_EVENT_NAME, {
        bubbles: true,
        detail: {code, message}
    });
    window.dispatchEvent(event);
};

export const throwErrorServer = (code: number, message: string) => {
    // Show generic message when internal server errors occur
    const codeStr = code < 900 ? getErrorCodeStr(code) : '900';
    throwError(code, getErrorCode()[codeStr] || message);
};

export const throwErrorClient = (code: number) => {
    const codeStr = getErrorCodeStr(code);
    const message = getErrorCode()[codeStr];
    if (!assertTrue(10, typeof message !== 'undefined')) { return; }
    throwError(code, message);
};

export const clearErrors = () => {
    const event = new CustomEvent(CUSTOM_ERROR.CLEAR_ERROR_EVENT_NAME, {bubbles: true});
    window.dispatchEvent(event);
};

export const getErrorCodeStr = (code: number) => {
    return ('000' + code).slice(-3);
};



// WEBPACK FOOTER //
// ./src/Util/errorUtil.ts